import { Grid } from "@mui/material";
import { ProductTypeQueryParam } from "application/store/models/seleccionarProductoPaso";
import {
  DISABLE_OBP_FLOW,
  OBP_UNAVAILABLE_MESSAGE,
} from "application/utils/constants";
import { Navigate, useLocation } from "react-router-dom";
import { GO_TO } from "infrastructure/api";
import Landing from "ui/components/molecules/Landing/Landing";
import QRLanding from "ui/components/molecules/Landing/QRLanding";

function LandingRouter() {
  const { search } = useLocation();
  const productType = new URLSearchParams(search).get("productType");

  if (
    DISABLE_OBP_FLOW &&
    productType === ProductTypeQueryParam.PymesParam
  ) {
    return (
      <Navigate
        to={GO_TO.SUCURSALES}
        state={{ customMessage: OBP_UNAVAILABLE_MESSAGE }}
        replace
      />
    );
  }

  return (
    <>
      <Grid sx={{ display: { md: "none" } }}>
        <Landing />
      </Grid>
      <Grid sx={{ display: { md: "block", xs: "none" } }}>
        <QRLanding />
      </Grid>
    </>
  );
}

export default LandingRouter;